'use client'

import type { Address } from 'my-purchases/types/purchaseCommon'

import styles from './AddressInfo.module.scss'

interface AddressInfoProps {
	readonly address: Address
	readonly 'data-testid': string
}
export function AddressInfo({
	address,
	'data-testid': dataTestId,
}: AddressInfoProps) {
	const { fullName, fullAddress, zipCode, city, phoneNumber, email } = address

	return (
		<div className={styles.address}>
			<p data-testid={`${dataTestId}.fullName`}>{fullName}</p>
			<p
				data-testid={`${dataTestId}.fullAddress`}
			>{`${fullAddress} ${zipCode}, ${city}`}</p>
			<p data-testid={`${dataTestId}.phone`}>{phoneNumber}</p>
			<p data-testid={`${dataTestId}.email`}>{email && email.toLowerCase()}</p>
		</div>
	)
}
